<template>
  <div class="problem">
    <el-divider content-position="left">常见问题</el-divider>
    <div style="display: inline-block">
      <el-button type="primary" size="mini" @click="handleAddOpen">添加</el-button>
    </div>
    <div style="width: 150px; display: inline-block">
      <el-select
        clearable
        v-model="catevalue"
        placeholder="请选择文章分类"
        size="mini"
        @change="cateSearch"
      >
        <el-option
          v-for="item in cateoptions"
          :key="item.id"
          :label="item.category_name"
          :value="item.category_name"
        >
        </el-option>
      </el-select>
    </div>
    <div style="width: 150px; display: inline-block">
      <el-input
        v-model="searchInput"
        size="mini"
        placeholder="标题"
        @blur="searchSome"
        @focus="clearSome"
      ></el-input>
    </div>

    <el-table
    height="calc(100vh - 276px)"
      :data="pageData"
      size="medium"
      style="width: 100%; margin-top: 0.2rem"
      border
    >
      <el-table-column
        v-for="(item, index) in col"
        :width="setTagWidth(item.prop)"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        fixed
      >
      </el-table-column>
      <el-table-column label="分类">
        <template slot-scope="scope">
          {{ getCateName(scope.row.cate_id) }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="140">
        <template slot-scope="scope">
          <!-- {{ scope.row.created_at }} -->
          <date-formatter :date-value="scope.row.created_at"></date-formatter>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="160">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row.id)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page-footer">
    <el-pagination
      background
      class="pagination-style"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    </div>
    <el-drawer
      title="添加问题"
      :visible.sync="addDrawer"
      :direction="direction"
      :before-close="handleAddDrawerClose"
      size="50%"
    >
      <el-upload
        class="avatar-uploader"
        :action="actionHost + '/api/upload/problem/cover'"
        accept="image/jpeg,image/png"
        :headers="uploadHeader"
        :show-file-list="false"
        :on-success="handleAddCoverSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <img v-if="addCoverUrl" :src="addCoverUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="11">
            <el-input placeholder="请输入标题" v-model="addData.problem_title" clearable>
            </el-input>
          </el-col>
          <el-col :span="11" :offset="1">
            <el-select v-model="addData.cate_id" filterable placeholder="请选择分类">
              <el-option
                v-for="item in selOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-input
              placeholder="请输入排序值"
              type="number"
              v-model="addData.sort_by"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="11" :offset="1" style="line-height: 35px">
            <span class="span_pd">是否显示</span>
            <el-tooltip
              :content="'Switch value: ' + addData.problem_status"
              placement="top"
            >
              <el-switch
                v-model="addData.problem_status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="显示"
                inactive-value="隐藏"
              >
              </el-switch>
            </el-tooltip>
          </el-col>
        </el-row>
        <vue-ueditor-wrap
          v-model="addData.problem_content"
          :config="myConfig"
        ></vue-ueditor-wrap>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleAdd">添加</el-button>
      </div>
    </el-drawer>
    <el-drawer
      title="编辑问题"
      :visible.sync="editDrawer"
      :direction="direction"
      :before-close="handleEditDrawerClose"
      size="50%"
    >
      <el-upload
        class="avatar-uploader"
        :action="actionHost + '/api/upload/problem/cover'"
        accept="image/jpeg,image/png"
        :headers="uploadHeader"
        :show-file-list="false"
        :on-success="handleEditCoverSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <img v-if="editCoverUrl" :src="editCoverUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="11">
            <el-input placeholder="请输入标题" v-model="saveData.problem_title" clearable>
            </el-input>
          </el-col>
          <el-col :span="11" :offset="1">
            <el-select v-model="saveData.cate_id" filterable placeholder="请选择分类">
              <el-option
                v-for="item in selOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-input
              placeholder="请输入排序值"
              v-model="saveData.sort_by"
              type="number"
              clearable
            >
            </el-input> </el-col
          >
          <el-col :span="11" :offset="1" style="line-height: 35px">
            <span class="span_pd">是否显示</span>
            <el-tooltip
              :content="'Switch value: ' + saveData.problem_status"
              placement="top"
            >
              <el-switch
                v-model="saveData.problem_status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="显示"
                inactive-value="隐藏"
              >
              </el-switch>
            </el-tooltip>
          </el-col>
        </el-row>
        <vue-ueditor-wrap
          v-model="saveData.problem_content"
          :config="myConfig"
        ></vue-ueditor-wrap>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleSave">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import DateFormatter from 'common/DateFormatter';
export default {
  name: "Problem",
  components: {
    VueUeditorWrap,
    DateFormatter
  },
  data() {
    return {
      catevalue: "",
      cateoptions: [],
      options: [],
      searchArt: [],
      list: [],
      loading: false,
      states: [],
      uploadHeader: { Authorization: localStorage.token },
      imgPath: 'https://qyhoss.oss-cn-hangzhou.aliyuncs.com/',
      problem: [],
      selOptions: [],
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      searchInput: "",
      col: [
        {
          label: "id",
          prop: "id",
        },
        {
          label: "顺序值",
          prop: "sort_by",
        },
        {
          label: "标题",
          prop: "problem_title",
        },
        {
          label: "是否显示",
          prop: "problem_status",
        },
        {
          label: "URL Link",
          prop: "url_link"
        },
      ],
      direction: "rtl",
      addDrawer: false,
      addCoverUrl: "",
      myConfig: {
        autoHeightEnabled: false,
        initialFrameHeight: 300,
        initialFrameWidth: "100%",
        serverUrl: this.$store.state.serverUrl,
        zIndex: 9999,
        toolbars: [
          [
            "fullscreen",
            "source",
            "|",
            "undo",
            "redo",
            "|",
            "bold",
            "italic",
            "underline",
            "fontborder",
            "strikethrough",
            "superscript",
            "subscript",
            "removeformat",
            "formatmatch",
            "autotypeset",
            "blockquote",
            "pasteplain",
            "|",
            "forecolor",
            "backcolor",
            "selectall",
            "cleardoc",
            "|",
            "rowspacingtop",
            "rowspacingbottom",
            "lineheight",
            "|",
            "paragraph",
            "fontfamily",
            "fontsize",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "indent",
            "|",
            "touppercase",
            "tolowercase",
            "imageleft",
            "imageright",
            "imagecenter",
            "simpleupload",
            "emotion",
            "preview",
          ],
        ],
      },
      addData: {
        cover: "",
        cate_id: null,
        sort_by: "",
        problem_title: "",
        problem_content: "",
        problem_status: "显示",
      },
      editDrawer: false,
      editCoverUrl: "",
      saveData: {
        id: null,
        index: null,
        cover: "",
        cate_id: null,
        sort_by: "",
        problem_title: "",
        problem_content: "",
        problem_status: "显示",
      },
    };
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    pageData: {
      get: function () {
        return this.problem.slice(
          this.pageOption.pageSize * (this.pageOption.currentPage - 1),
          this.pageOption.pageSize * this.pageOption.currentPage
        );
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    getProblemData() {
      this.$axios.get("/api/admin/problem").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.problem = data.data.problem;
          this.cateoptions = data.data.cate;
          this.pageOption.total = this.problem.length;
          this.selOptions = data.data.cate;
        }
      });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
    },
    handleAddDrawerClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearAddData();
          done();
        })
        .catch((_) => {});
    },
    handleAddOpen() {
      this.addDrawer = true;
    },
    handleAddCoverSuccess(res, file) {
      if (res.code === 0) {
        this.addCoverUrl = URL.createObjectURL(file.raw);
        this.addData.cover = this.imgPath + res.data.store_result;
      } else {
        this.$message.error(res.msg);
      }
    },
    beforeAvatarUpload(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message.error("封面只能是 JPG、PNG 格式!");
        return false;
      }

      return true;
    },
    handleAdd() {
      if (!this.addData.problem_title) {
        this.$message.error("标题不能为空");
        return;
      }

      if (!this.addData.cate_id) {
        this.$message.error("请选择分类");
        return;
      }

      if (!this.addData.problem_content) {
        this.$message.error("内容不能为空");
        return;
      }

      this.$axios
        .post("/api/admin/problem/add", {
          cate_id: this.addData.cate_id,
          cover: this.addData.cover,
          sort_by: parseInt(this.addData.sort_by),
          problem_title: this.addData.problem_title,
          problem_status: this.addData.problem_status,
          problem_content: this.addData.problem_content,
        })
        .then((res) => {
          console.log(res);
          const { data } = res;
          if (data.code === 0) {
            this.getProblemData();
            // this.problem.unshift(data.data)
            // this.pageOption.total = this.problem.length
            this.$message.success(data.msg);
            this.clearAddData();
            this.addDrawer = false;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    clearAddData() {
      this.addData.cate_id = null;
      this.addCoverUrl = "";
      this.addData.cover = "";
      this.addData.sort_by = "";
      this.addData.problem_title = "";
      this.addData.problem_status = "显示";
      this.addData.problem_content = "";
    },
    handleEdit(index, row) {
      this.saveData.id = row.id;
      this.saveData.index = index;
      this.saveData.cate_id = row.cate_id;
      this.saveData.cover = row.cover;
      this.editCoverUrl = row.cover;
      this.saveData.sort_by = row.sort_by;
      this.saveData.problem_title = row.problem_title;
      this.saveData.problem_status = row.problem_status;
      this.saveData.problem_content = row.problem_content;
      this.editDrawer = true;
    },
    clearSaveData() {
      this.saveData.id = null;
      this.saveData.index = null;
      this.saveData.cate_id = null;
      this.saveData.cover = "";
      this.editCoverUrl = "";
      this.saveData.sort_by = "";
      this.saveData.problem_title = "";
      this.saveData.problem_status = "显示";
      this.saveData.problem_content = "";
    },
    handleEditCoverSuccess(res, file) {
      if (res.code === 0) {
        this.editCoverUrl = URL.createObjectURL(file.raw);
        this.saveData.cover = this.imgPath + res.data.store_result;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleEditDrawerClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearSaveData();
          done();
        })
        .catch((_) => {});
    },
    handleSave() {
      if (!this.saveData.id) {
        this.$message.error("请求错误");
        return;
      }

      if (this.saveData.index === null) {
        this.$message.error("请求错误");
        return;
      }

      if (!this.saveData.cate_id) {
        this.$message.error("请求错误");
        return;
      }

      if (!this.saveData.problem_title) {
        this.$message.error("标题不能为空");
        return;
      }

      if (!this.saveData.problem_content) {
        this.$message.error("内容不能为空");
        return;
      }

      this.$axios
        .post("/api/admin/problem/save", {
          id: this.saveData.id,
          cate_id: this.saveData.cate_id,
          cover: this.saveData.cover,
          sort_by: parseInt(this.saveData.sort_by),
          problem_title: this.saveData.problem_title,
          problem_content: this.saveData.problem_content,
          problem_status: this.saveData.problem_status,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.getProblemData();
            // let index = this.pageOption.pageSize * (this.pageOption.currentPage - 1) + this.saveData.index
            // this.problem[index].cover = this.saveData.cover
            // this.problem[index].cate_id = this.saveData.cate_id
            // this.problem[index].sort_by = this.saveData.sort_by
            // this.problem[index].problem_title = this.saveData.problem_title
            // this.problem[index].problem_content = this.saveData.problem_content
            // this.problem[index].problem_status = this.saveData.problem_status
            this.$message.success(data.msg);
            this.clearSaveData();
            this.editDrawer = false;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleDelete(index, id) {
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDeleteSub(index, id);
        })
        .catch(() => {});
    },
    handleDeleteSub(index, id) {
      this.$axios.post("/api/admin/problem/del", { id }).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          let idx = this.pageOption.pageSize * (this.pageOption.currentPage - 1) + index;
          this.problem.splice(idx, 1);
          this.pageOption.total = this.problem.length;
          if (index === 0) this.prePage();
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    prePage() {
      if (this.pageOption.currentPage === 1) return;
      this.pageOption.currentPage = this.pageOption.currentPage - 1;
    },
    getCateName(id) {
      for (var i = 0; i < this.selOptions.length; i++) {
        if (this.selOptions[i].id === id) return this.selOptions[i].category_name;
      }
    },
    setTagWidth(prop) {
      let width = "";
      if (prop === "id") {
        width = 90;
      }
      if (prop === "sort_by") {
        width = 90;
      }
      if (prop === "problem_status") {
        width = 90;
      }
      return width;
    },
    searchSome() {
      this.$axios
        .get("/api/admin/problem", {
          params: {
            par: this.searchInput,
            catename: this.catevalue,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.problem = data.data.problem;
            this.pageOption.total = this.problem.length;
            this.selOptions = data.data.cate;
          }
        });
    },
    cateSearch() {
      this.$axios
        .get("/api/admin/problem", {
          params: {
            category_name: this.catevalue,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.problem = data.data.problem;
            this.cateoptions = data.data.cate;
            this.pageOption.total = this.problem.length;
            this.selOptions = data.data.cate;
          }
        });
    },
    clearSome() {
      this.searchInput = "";
    },
  },
  mounted() {
    this.getProblemData();
    this.list = this.states.map((item) => {
      return { value: item, label: item };
    });
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
.el-dialog__wrapper >>> .el-drawer
  overflow-y: auto
.m-tabs-content
  padding: 0 .2rem 0 .4rem
.addCon
  margin: .2rem 0
  text-align: right
.el-row
  margin-bottom: .2rem
.el-select
  width: 100%
.avatar-uploader
  text-align: center
  margin-bottom: .2rem
.avatar-uploader >>> .el-upload
  border: .02rem dashed #d9d9d9
  border-radius: .12rem
  cursor: pointer
  position: relative
  overflow: hidden
.avatar-uploader >>> .el-upload:hover
  border-color: #409eff
.avatar-uploader >>> .el-upload img
  width: 4rem
  height: 2rem
.avatar-uploader-icon
  font-size: .4rem
  color: #8c939d
  width: 4rem
  height: 2rem
  line-height: 2rem
  text-align: center
.problem
  marginLeft()
.page-footer
  position: fixed
  bottom: 0
  left: 0
  height: 80px
  background: #fff
  width: 100%
  z-index: 2
.pagination-style
  padding-top: 15px
  text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/problem/Problem.vue